import http from './request';
import { isProd } from '@/lib/utils';
export default function errReport({
  type = 'unknown',
  from = '',
  target = '',
  message = '',
  trace = '',
  request = {},
  response = {},
}) {
  return Promise.resolve();
  // const data = {
  //   id: 72, // 项目号
  //   uin: 'service-center',
  //   msg: message, //错误信息
  //   target, //错误目标接口或文件或组件
  //   from: location.href, //来源链接
  // };
  // console.error(data);
  // isProd &&
  //   http.post('https://apm-collect.qiyuan333.cn/api/error', {
  //     appId: 'M69',
  //     url: window.location.href,
  //     from,
  //     type,
  //     message,
  //     trace,
  //     target,
  //     request,
  //     response,
  //   });
}
